module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-change-password clearfix"
  }, [_c('div', {
    staticClass: "box-title"
  }, [_vm._v(_vm._s(_vm.labels['60']))]), _vm._v(" "), (_vm.flgAction !== 'login') ? _c('label', {
    staticClass: "box-input-material position-up clearfix"
  }, [_c('div', {
    staticClass: "glyphicon glyphicon-user icon-id"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "upper",
    class: {
      'focus': _vm.username != '', 'input-error': _vm.errors.has('username')
    },
    attrs: {
      "name": "username"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "keyup": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.flgAction === 'forgot' ? _vm.$refs.newPasswordInput.focus() : _vm.$refs.passwordInput.focus()
      }, function($event) {
        _vm.clearResponse()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.labels['20']))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('username')),
      expression: "errors.has('username')"
    }],
    staticClass: "login-validate"
  }, [_vm._v(_vm._s(_vm.errors.first('username')))])]) : _vm._e(), _vm._v(" "), (_vm.flgAction === 'change') ? _c('label', {
    staticClass: "box-input-material clearfix"
  }, [_c('div', {
    staticClass: "fa fa-key icon-id"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    ref: "passwordInput",
    class: {
      'focus': _vm.password != '', 'input-error': _vm.errors.has('password')
    },
    attrs: {
      "type": "password",
      "name": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "keyup": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.$refs.newPasswordInput.focus()
      }, function($event) {
        _vm.clearResponse()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.labels['80']))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('password')),
      expression: "errors.has('password')"
    }],
    staticClass: "login-validate"
  }, [_vm._v(_vm._s(_vm.errors.first('password')))])]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "input-password box-input-material clearfix"
  }, [_c('div', {
    staticClass: "fa fa-key icon-id"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPassword),
      expression: "newPassword"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    ref: "newPasswordInput",
    class: {
      'focus': _vm.newPassword != '', 'input-error': _vm.errors.has('newPassword')
    },
    attrs: {
      "type": "password",
      "name": "newPassword"
    },
    domProps: {
      "value": (_vm.newPassword)
    },
    on: {
      "keyup": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.$refs.confirmNewPasswordInput.focus()
      }, function($event) {
        _vm.clearResponse()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPassword = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.labels['90']))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('newPassword')),
      expression: "errors.has('newPassword')"
    }],
    staticClass: "login-validate"
  }, [_vm._v(_vm._s(_vm.errors.first('newPassword')))])]), _vm._v(" "), _c('label', {
    staticClass: "input-password box-input-material clearfix"
  }, [_c('div', {
    staticClass: "fa fa-key icon-id"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.confirmNewPassword),
      expression: "confirmNewPassword"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|confirmed:newPassword'),
      expression: "'required|confirmed:newPassword'"
    }],
    ref: "confirmNewPasswordInput",
    class: {
      'focus': _vm.confirmNewPassword != '', 'input-error': _vm.errors.has('confirmNewPassword')
    },
    attrs: {
      "type": "password",
      "name": "confirmNewPassword"
    },
    domProps: {
      "value": (_vm.confirmNewPassword)
    },
    on: {
      "keyup": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.validateInput()
      }, function($event) {
        _vm.clearResponse()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.confirmNewPassword = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.labels['100']))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('confirmNewPassword')),
      expression: "errors.has('confirmNewPassword')"
    }],
    staticClass: "login-validate"
  }, [_vm._v(_vm._s(_vm.errors.first('confirmNewPassword')))])]), _vm._v(" "), (_vm.loadingDisp) ? _c('div', {
    staticClass: "infinite-loading-container"
  }, [_c('i', {
    staticClass: "loading-wave-dots"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.changePasswordResponse !== ''),
      expression: "changePasswordResponse !== ''"
    }],
    staticClass: "response-msg",
    class: _vm.getStatusResponse
  }, [_c('div', [_vm._v(_vm._s(_vm.changePasswordResponse))]), _vm._v(" "), _vm._l((_vm.formatPassword), function(msgFormat, index) {
    return _c('div', {
      key: index,
      staticClass: "format-password"
    }, [_vm._v("\n      " + _vm._s(msgFormat.message_alert) + "\n    ")])
  })], 2), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.dispBtnOk),
      expression: "!dispBtnOk"
    }],
    staticClass: "btn-change submit",
    on: {
      "click": function($event) {
        _vm.validateInput()
      }
    }
  }, [_vm._v(_vm._s(_vm.labels['120']))]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.dispBtnOk),
      expression: "!dispBtnOk"
    }],
    staticClass: "btn-change cancel",
    on: {
      "click": function($event) {
        _vm.cancel()
      }
    }
  }, [_vm._v(_vm._s(_vm.labels['110']))]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dispBtnOk),
      expression: "dispBtnOk"
    }],
    staticClass: "btn-change submit",
    on: {
      "click": function($event) {
        _vm.cancel()
      }
    }
  }, [_vm._v(_vm._s(_vm.labels['130']))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0c56eb08!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/login/changePassword.vue
// module id = 3546
// module chunks = 1